import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Table } from "../../../components/Table/Table";
import { companyDetails, sitesCompanyList } from "../../redux/api/dummyJson";
import {
  green_icon,
  red_icon,
  search_icon,
  view_icon,
} from "../../../assets/imgs";
import SelectBox from "../../../components/SelectBox";
import { get, post } from "../../../Services/ApiHandler";
import { URL } from "../../../Services/Constant";
import moment from "moment/moment";
import FavoriteIcon from "@mui/icons-material/Favorite";

const SitesList = () => {
  const navigate = useNavigate();
  const givenpermissions = JSON.parse(localStorage.getItem("user_permission"));
  const [list, setList] = useState([]);
  const [page, setPage] = useState(1);
  const [comapanyList, setCompanyList] = useState([]);

  const [pagination, setPagination] = useState(1);

  const [popup, setPopup] = useState(false);

  const [data, setData] = useState([]);
  const [selectedOption, setSelectedOption] = useState(null);

  // company name with ID, comapany admin & email id, Site name and site code, Site location, site admin (Name, email id, Mobile number) and ,status, view

  const columns = React.useMemo(
    () => [
      {
        Header: "S.No",
        accessor: "sno",
        Cell: ({ value, row }) => {
          return <p>{(page - 1) * 10 + row.index + 1}</p>;
        },
      },
      {
        Header: "Company name & ID",
        accessor: "",
        Cell: ({ value, row }) => {
          return (
            <div className="d-flex flex-column gap-2">
              <p>{row.original.company_name}</p>
              <p>{row.original.company_code}</p>
            </div>
          );
        },
      },
      {
        Header: "Company admin & Email",
        accessor: "",
        Cell: ({ value, row }) => {
          return (
            <div className="d-flex flex-column gap-2">
              <p>{row.original.owner_name}</p>
              <p>{row.original.owner_email}</p>
              <div className="d-flex ac-jc mb-2 gap-2">
                <img
                  src={
                    row?.original?.owner_is_email_verified
                      ? green_icon
                      : red_icon
                  }
                  className="redImg"
                />
                <p className="f2 fs-sm-9 fs-md-11 fs-lg-13 fs-xl-15 fs-xxl-17 mb-1 primary">
                  {row?.original?.owner_is_email_verified
                    ? "Verified"
                    : "Not Verified"}
                </p>
              </div>
            </div>
          );
        },
      },
      {
        Header: "Company CreatedAt",
        accessor: "created_at",
        Cell: ({ value, row }) => {
          return <p>{value ? moment(value).format("DD-MM-YYYY") : ""}</p>;
        },
      },
      {
        Header: "Site Name & Code",
        accessor: "",
        Cell: ({ value, row }) => {
          return (
            <div className="d-flex flex-column gap-2">
              <p>{row.original.site_name}</p>
              <p>{row.original.site_code}</p>
            </div>
          );
        },
      },
      {
        Header: "Site location",
        accessor: "site_location",
        Cell: ({ value, row }) => {
          return <p>{value}</p>;
        },
      },
      {
        Header: "Site Admin Name & Email",
        accessor: "",
        Cell: ({ value, row }) => {
          return (
            <div className="d-flex flex-column gap-2">
              <p>{row.original.user_name}</p>
              <p>{row.original.user_email}</p>
              <div className="d-flex ac-jc mb-2 gap-2">
                <img
                  src={row?.original?.is_email_verified ? green_icon : red_icon}
                  className="redImg"
                />
                <p className="f2 fs-sm-9 fs-md-11 fs-lg-13 fs-xl-15 fs-xxl-17 mb-1 primary">
                  {row?.original?.is_email_verified
                    ? "Verified"
                    : "Not Verified"}
                </p>
              </div>
            </div>
          );
        },
      },
      {
        Header: "Site admin mobile",
        accessor: "user_phone",
        Cell: ({ value, row }) => {
          return <p>{value}</p>;
        },
      },
      {
        Header: "Site created by",
        accessor: "created_by",
        Cell: ({ value, row }) => {
          return <p>{row.original.owner_name}</p>;
        },
      },
      {
        Header: "Company Admin",
        accessor: "owner_name",
        Cell: ({ value, row }) => {
          return <p>{value}</p>;
        },
      },
      {
        Header: "Status",
        accessor: "status",
        Cell: ({ value, row }) => {
          return (
            <div>
              <button
                disabled={true}
                className={`${
                  value == 1 ? "active-btn" : "deactive-btn"
                } border-0  fs-sm-10 fs-md-12 fs-lg-14 fs-xl-13 opacity-50`}
                onClick={() => {
                  if (givenpermissions?.includes("CAN-Status-KNF_ADMIN_SITE")) {
                    console.log("");
                  }
                }}
              >
                {value == 1 ? "Active" : "De-active"}
              </button>
            </div>
          );
        },
      },
      {
        Header: "Device Status",
        accessor: "device_status",
        Cell: ({ value, row }) => {
          return (
            <div>
              <button className={`border-0 toggle-btn cust-btn `}>
                {value == 1 ? (
                  <div>
                    <FavoriteIcon className="green" />
                  </div>
                ) : (
                  <div>
                    <FavoriteIcon className="red" />
                  </div>
                )}
              </button>
            </div>
          );
        },
      },
      {
        Header: "Service Status",
        accessor: "service_status",
        Cell: ({ value, row }) => {
          return (
            <div>
              <button className={`border-0 toggle-btn cust-btn `}>
                {value == 1 ? (
                  <div>
                    <FavoriteIcon className="green" />
                  </div>
                ) : (
                  <div>
                    <FavoriteIcon className="red" />
                  </div>
                )}
              </button>
            </div>
          );
        },
      },
      {
        Header: "Description",
        accessor: "service_error",
        Cell: ({ value, row }) => {
          return <div className="d-flex flex-column gap-2">{value}</div>;
        },
      },
      {
        Header: "Action",
        accessor: "",
        Cell: ({ value, row }) => {
          return (
            <React.Fragment>
              <div className="d-flex ac-jc gap-3">
                {givenpermissions?.includes("CAN-View-KNF_ADMIN_SITE") && (
                  <button
                    onClick={() => {
                      navigate("/sites-view", {
                        state: { type: "view", data: row.original },
                      });
                      // AdminView(row.original.id, "view");
                    }}
                    className="cust-btn "
                  >
                    <img src={view_icon} alt="" className=" edit-btn " />
                  </button>
                )}
              </div>
            </React.Fragment>
          );
        },
      },
    ],
    [page]
  );

  const getCompanyList = () => {
    post(URL.COMPANY_LIST_ADMIN, {})
      .then((res) => {
        setCompanyList(res?.companies);
      })
      .catch((err) => {
        console.log("err", err);
      });
  };

  const getSiteList = (company) => {
    let formdata = new FormData();
    if (company?.value) {
      formdata.append("company_id", company?.value);
    }
    setSelectedOption(company);
    formdata.append("page", page);
    post(URL.SITE_LIST_ADMIN, formdata)
      .then((res) => {
        setPagination(res?.pagination_meta);
        setList(res?.lists);
      })
      .catch((err) => {
        console.log("err", err);
      });
  };

  useEffect(() => {
    getCompanyList();
  }, []);

  useEffect(() => {
    getSiteList(selectedOption);
  }, [page]);

  return (
    <div className="dashRightView ">
      <div className="d-flex ac-jb">
        <h2 className=" f3 fs-sm-16 fs-md-20 fs-lg-22 fs-xl-24 fs-xxl-26 ">
          Total:{pagination?.total ?? 0}
        </h2>
        <div className="d-flex gap-3">
          <div style={{}}>
            <SelectBox
              arrayData={comapanyList}
              data={data}
              setData={setData}
              selectedOption={selectedOption}
              setSelectedOption={getSiteList}
            />
          </div>
          <div className="search-input">
            <input
              //  onChange={(e) => (adminList(1, e.target.value))}
              type="text"
              placeholder="Search"
              style={{ border: "none", width: "150px" }}
            />
            <img src={search_icon} className="search" />
          </div>
          {/* {rolePermissions?.includes('CAN-ADD-ADMIN') && */}
          {/* } */}
        </div>
      </div>
      <Table
        columns={columns}
        setPageno={setPage}
        pagecount={pagination}
        data={list ?? []}
        show={true}
      />
      {popup && (
        <div className="img-popup-design">
          <div className="img-popup">
            <p className="f3 ms-2  ms-md-2 ms-lg-2 ms-xl-2 fs-xs-10 fs-sm-11 fs-md-12 fs-lg-13 fs-xl-14 fs-xxl-15 mt-4">
              Are you sure, want to Delete?
            </p>
            <div className="d-flex ac-jb px-2 mt-5">
              <button onClick={() => setPopup(false)} className="add-btn w-40">
                Yes
              </button>
              <button
                onClick={() => {
                  setPopup(false);
                  // logout();
                }}
                className="back-btn f2 w-40"
              >
                {/* {loading ? "Loading..." : "Confirm"} */}No
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default SitesList;
